import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RestApiService } from '../services/restapi.service';

@Component({
    selector: 'app-email-verify-dialog',
    templateUrl: './email-verify-dialog.component.html',
    styleUrls: ['./email-verify-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailVerifyDialogComponent implements OnInit, OnDestroy {
  emailNotVerified: boolean = false;
  emailVerified: boolean = false;
  showExplain: boolean = true;
  closing_Allowed: boolean;
  public interval:any;
  showErrorConfirmationCode: boolean = false;
  confirmationCodeErrorMessage: string = "";
  confirmationCode: string = "";


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EmailVerifyDialogComponent>,
    public apiService: RestApiService) { }

  ngOnInit(): void {
    this.verifyemailbylink(this.data.email)
  }
  verifyemailbylink(e) {
    this.showExplain = true

    document.getElementsByClassName('loading-spinner')[0].classList.add('hidden')
    const request = {
      Email: e
    };

    this.apiService.sendemail(request).subscribe((response: any) => {})
    clearInterval(this.interval)
  }

  checkConfirmationCode(): any {
    if ( this.confirmationCode.length >= 6 ) {
      this.apiService.CheckConfirmationCode(this.data.email, this.confirmationCode).subscribe((response: any) => {
        if ((response.Data == true) && (response.Message == "Success")) {
        this.emailNotVerified = false
        this.emailVerified = true
        this.showExplain = false
        this.data.service.isNOTverified_email = false
        this.dialogRef.close({ verified: this.emailVerified });
        clearInterval(this.interval)
        this.showErrorConfirmationCode = false;
        this.confirmationCodeErrorMessage = "";
      } else if ((response.Data == false) && (response.Message == "Success")) {
        this.showErrorConfirmationCode = true;
        this.data.service.isNOTverified_email = true;
        this.confirmationCodeErrorMessage = "invalid_confirmation_code";
      }
    });
  }
}

  ngOnDestroy(): void {
    this.dialogRef.close({ verified: this.emailVerified });
  }
}
